// extracted by css-extract-rspack-plugin
export default {"structure":"yjCA2NrfPYUHLwMi","count":"f2vca546UTUvliM9"};